export default defineNuxtPlugin((nuxtApp) => {
  const t = nuxtApp.vueApp.config.globalProperties.$t
  nuxtApp.provide('t', t)
})